import fetch from "@/utils/request";


export default {
  getHelpList(data?: object): any {
    return fetch({
      url: "/php/api/help/lists",
      method: "get",
      data
    });
  },

  getHelpDetail(data?: object): any {
    return fetch({
      url: "/php/api/help/detail",
      method: "get",
      data
    });
  }
};
